import { UserCircleIcon } from 'lucide-react';

import { Button } from './Button';
import { useRootLoaderData } from '@/hooks/useRootLoaderData';

export const UserNavigation = () => {
  const { currentUser } = useRootLoaderData();

  return (
    <div>
      {currentUser && (
        <div className="hidden lg:block">
          <Button
            to="/account"
            variant="secondary"
            size="sm"
            icon={UserCircleIcon}
          >
            Account
          </Button>
        </div>
      )}
    </div>
  );
};
